import * as React from "react";
import { cn } from "@/lib/utils";

const Table = React.forwardRef<HTMLTableElement, React.HTMLAttributes<HTMLTableElement>>(
  ({ className, ...props }, ref) => <table ref={ref} className={cn("data-table", className)} {...props} />
);
Table.displayName = "Table";

const TableWrapper = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("overflow-x-auto rounded-lg border border-line bg-surface", className)}
      {...props}
    />
  )
);
TableWrapper.displayName = "TableWrapper";

export { Table, TableWrapper };